import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { SharedService } from 'src/app/Services/shared.service';
import { SlackAuthTokenService } from 'src/app/Services/slack-auth-token.service';
import { getBrand } from 'src/environments/brand';

@Component({
  selector: 'ze-slack-integration',
  templateUrl: './slack-integration.component.html',
  styleUrls: ['./slack-integration.component.scss']
})
export class SlackIntegrationComponent implements OnInit {
  brand = getBrand();
  isSlackIntegrationExists: boolean = false;
  slackIntegrationUrl: string = null;
  myData: any[] = [];
  returnUrl: string;

  private subscriptions: Subscription = new Subscription();
  constructor(private route: ActivatedRoute, private sharedService: SharedService, private slack_authService: SlackAuthTokenService, private router: Router) { }

  ngOnInit() {
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/project';
    this.checkIsSlackIntegrated();

    this.sharedService.loaderHide.emit(true);
    this.subscriptions.add(this.route.queryParams.subscribe(params => {
      if (params["code"]) {
        this.slack_authService.slackAuthToken(params["code"]).subscribe(data => {
          if (data["data"] == null) {
            this.isSlackIntegrationExists = false;
            this.getSlackIntegrationUrl();
          } else {
            this.isSlackIntegrationExists = true;
            this.getSlackIntegrationUrl();
            this.sharedService.loaderHide.emit(false);
          }
          this.navigateToSlack();
        }, error => {
          this.sharedService.loaderHide.emit(false);
        });
      } else {
        this.checkIsSlackIntegrated();
      }
    }));
  }

  checkIsSlackIntegrated() {
    this.slack_authService.isSlackIntegrationAvailable().subscribe(data => {
      this.myData = data["data"];
      if (data["data"] == null) {
        this.isSlackIntegrationExists = false;
        this.getSlackIntegrationUrl();
      } else {
        this.isSlackIntegrationExists = true;
        this.getSlackIntegrationUrl();
        this.sharedService.loaderHide.emit(false);
      }
    }, error => {
      this.sharedService.loaderHide.emit(false);
    });
  }

  navigateToSlack(): void {
    this.router.navigate([this.router.url.split('?')[0]], { queryParams: {} });
  }

  getSlackIntegrationUrl() {
    this.slack_authService.getSlackIntegrationUrl().subscribe(data => {
      if (data["data"] == null || data["operationStatus"] == "ERROR") {
        this.slackIntegrationUrl = null;
      } else {
        this.slackIntegrationUrl = data["data"];
      }
      this.sharedService.loaderHide.emit(false);
    }, error => {
      this.sharedService.loaderHide.emit(false);
    });
  }

  integrateSlack(): void {
    if (this.slackIntegrationUrl) {
      window.location.href = this.slackIntegrationUrl;
    }
  }

  integrateWorkspace(workspace: any) {
    workspace.integrated = true;
  }

  navigatePreviousUrl(): void {
    this.router.navigateByUrl(this.returnUrl);
  }
}
